import api from './api';

const companyPatnersService = {
  // Obtener todos los company patners
  getCompanyPatners: async () => {
    try {
      const response = await api.get('/api/CompanyPatners');
      return response.data;
    } catch (error) {
      console.error('Error al obtener company patners:', error);
      throw error;
    }
  },

  // Obtener un company patner por ID
  getCompanyPatnerById: async (id) => {
    try {
      const response = await api.get(`/api/CompanyPatners/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener company patner con ID ${id}:`, error);
      throw error;
    }
  },

  // Obtener un company patner con sus unidades residenciales
  getCompanyPatnerWithUnidades: async (id) => {
    try {
      const response = await api.get(`/api/CompanyPatners/${id}/with-unidades`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener company patner con unidades, ID ${id}:`, error);
      throw error;
    }
  },

  // Crear un nuevo company patner
  createCompanyPatner: async (companyPatnerData) => {
    try {
      // Validaciones
      if (!companyPatnerData.name || companyPatnerData.name.trim() === '') {
        throw new Error('El nombre es requerido');
      }
      
      if (!companyPatnerData.email_patner_company || companyPatnerData.email_patner_company.trim() === '') {
        throw new Error('El email es requerido');
      }

      // Validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(companyPatnerData.email_patner_company)) {
        throw new Error('El formato del email no es válido');
      }

      if (companyPatnerData.number_unidades !== undefined && companyPatnerData.number_unidades < 0) {
        throw new Error('El número de unidades no puede ser negativo');
      }

      if (companyPatnerData.businness_patners !== undefined) {
        const percentage = parseFloat(companyPatnerData.businness_patners);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      const response = await api.post('/api/CompanyPatners', companyPatnerData);
      return response.data;
    } catch (error) {
      console.error('Error al crear company patner:', error);
      throw error;
    }
  },

  // Actualizar un company patner existente
  updateCompanyPatner: async (id, companyPatnerData) => {
    try {
      // Validaciones
      if (companyPatnerData.name !== undefined && companyPatnerData.name.trim() === '') {
        throw new Error('El nombre no puede estar vacío');
      }

      if (companyPatnerData.email_patner_company !== undefined) {
        if (companyPatnerData.email_patner_company.trim() === '') {
          throw new Error('El email no puede estar vacío');
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(companyPatnerData.email_patner_company)) {
          throw new Error('El formato del email no es válido');
        }
      }

      if (companyPatnerData.number_unidades !== undefined && companyPatnerData.number_unidades < 0) {
        throw new Error('El número de unidades no puede ser negativo');
      }

      if (companyPatnerData.businness_patners !== undefined) {
        const percentage = parseFloat(companyPatnerData.businness_patners);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      const response = await api.put(`/api/CompanyPatners/${id}`, companyPatnerData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar company patner con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar un company patner
  deleteCompanyPatner: async (id) => {
    try {
      const response = await api.delete(`/api/CompanyPatners/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar company patner con ID ${id}:`, error);
      throw error;
    }
  }
};

export default companyPatnersService;
